// extracted by mini-css-extract-plugin
module.exports = {"root":"r_bJ"};